import { ReactNode, useCallback, useMemo } from 'react';
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard';
import extractTextContent from './extractTextContent';

interface UseCopyMessageResult {
  isCopied: boolean;
  handleCopy: VoidFunction;
  handlePointerEnter: VoidFunction;
}

const useCopyMessage = (content: ReactNode): UseCopyMessageResult => {
  const copyText = useMemo(() => extractTextContent(content), [content]);
  const { isCopied, copy, reset } = useCopyToClipboard({ showErrorToast: true, resetAfterMs: null });

  const handleCopy = useCallback(() => {
    copy(copyText);
  }, [copy, copyText]);

  const handlePointerEnter = useCallback(() => {
    reset();
  }, [reset]);

  return { isCopied, handleCopy, handlePointerEnter };
};

export default useCopyMessage;
